import request from '@/utils/request'

//流程相关api
export async function getProcNode(data) {
  return request({
    url: '/processNode/all',
    method: 'post',
    data,
  })
}

export async function createProcNode(data) {
  return request({
    url: '/v2/processNode/save',
    method: 'post',
    data,
  })
}
export async function updateProcNode(data) {
  return request({
    url: '/v2/processNode/update',
    method: 'post',
    data,
  })
}
export async function deleteProcNode(data) {
  return request({
    url: '/processNode/delete',
    method: 'post',
    data,
  })
}
export async function getProc(data) {
  return request({
    url: '/process/all',
    method: 'post',
    data,
  })
}

export async function createProc(data) {
  return request({
    url: '/process/save',
    method: 'post',
    data,
  })
}
export async function updateProc(data) {
  return request({
    url: '/process/update',
    method: 'post',
    data,
  })
}
export async function deleteProc(data) {
  return request({
    url: '/process/delete',
    method: 'post',
    data,
  })
}
export async function getProcDef(data) {
  return request({
    url: '/processDefinition/all',
    method: 'post',
    data,
  })
}

export async function createProcDef(data) {
  return request({
    url: '/v2/processDefinition/save',
    method: 'post',
    data,
  })
}
export async function updateProcDef(data) {
  return request({
    url: '/processDefinition/update',
    method: 'post',
    data,
  })
}
export async function deleteProcDef(data) {
  return request({
    url: '/processDefinition/delete',
    method: 'post',
    data,
  })
}
